import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// EditorPanel.tsx — the left panel: a host for the editor pages. All pages stay mounted (toggled
// with `hidden`) so their state survives switching pages. Owns the cross-page handoff: opening an
// Editor Level hands its template to the Level Editor page and navigates there.
//
// The page is chosen by the ROUTE now — the tab bar that used to live here moved into the top menu
// (see shell/Header.tsx). Everything else is unchanged, including the all-pages-mounted trick,
// which is what keeps a half-finished generation alive while you look at something else.
import { Component } from "react";
import { WelcomePage } from "./pages/WelcomePage";
import { GeneratePage } from "./pages/GeneratePage";
import { LevelsPage } from "./pages/LevelsPage";
import { DeploymentsPage } from "./pages/DeploymentsPage";
import { LevelEditorPage } from "./pages/LevelEditorPage";
import { SrOptionsPage } from "./pages/SrOptionsPage";
export class EditorPanel extends Component {
    constructor() {
        super(...arguments);
        this.state = { loadTemplate: null, loadToken: 0 };
        // Called by the Levels page: hand the template to the editor, then go there.
        this.openInEditor = (template) => {
            this.setState((s) => ({ loadTemplate: template, loadToken: s.loadToken + 1 }), () => this.props.onOpenLevelEditor());
        };
    }
    render() {
        const { tab } = this.props;
        const { loadTemplate, loadToken } = this.state;
        return (
        // The environment picker used to be a bar here, above every page. It moved into the
        // Levels page (choosing) and TargetChip in the Level Editor (where the write happens),
        // so the panel is nothing but the page host now.
        _jsx("div", { className: "flex h-full flex-1 flex-col overflow-hidden bg-slate-900 text-slate-100", children: _jsxs("div", { className: "min-h-0 flex-1 bg-slate-900", children: [_jsx("div", { className: tab === "welcome" ? "h-full" : "hidden", children: _jsx(WelcomePage, {}) }), _jsx("div", { className: tab === "generate" ? "h-full" : "hidden", children: _jsx(GeneratePage, {}) }), _jsx("div", { className: tab === "levels" ? "h-full" : "hidden", children: _jsx(LevelsPage, { onOpen: this.openInEditor }) }), _jsx("div", { className: tab === "editor" ? "h-full" : "hidden", children: _jsx(LevelEditorPage, { active: tab === "editor", loadTemplate: loadTemplate, loadToken: loadToken, onPickEnvironment: this.props.onOpenLevels }) }), _jsx("div", { className: tab === "deployments" ? "h-full" : "hidden", children: _jsx(DeploymentsPage, {}) }), _jsx("div", { className: tab === "srOptions" ? "h-full" : "hidden", children: _jsx(SrOptionsPage, {}) })] }) }));
    }
}
